module.exports = __webpack_public_path__ + "static/img/slide1_x4.03748c7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sources/original-slides/slide1_x4.jpeg
// module id = 2NRX
// module chunks = 1